import { render, staticRenderFns } from "./CreateDecisionPoint.vue?vue&type=template&id=204492d6&"
import script from "./CreateDecisionPoint.vue?vue&type=script&lang=js&"
export * from "./CreateDecisionPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports